import {
  Placement,
  PoiCategoryDto,
  PoiProperties,
  RequestPoi,
  IndoorviewPoiInfo
} from '@/interfaces/poi.interface'
import { getRequestv1, postRequest, postRequestGateway, putRequestGateway } from './api.service'

export async function getPoisGeojsonForBuilding(
  constructionId,
  categoryId,
  cancelPendingRequest = false
) {
  let endpoint = `/v2/pois/constructions/${constructionId}/geojson`
  if (categoryId) {
    endpoint += `?categoryId=${categoryId}`
  }
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {}
}
export async function getPoisGeojsonForRealEstate(
  realEstateId,
  categoryId,
  cancelPendingRequest = false
) {
  let endpoint = `/v2/pois/realestate/${realEstateId}/geojson`
  if (categoryId) {
    endpoint += `?categoryId=${categoryId}`
  }
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {}
}

export async function getPoiCategoriesForRealm(
  placement: Placement | undefined = undefined,
  cancelPendingRequest = false
): Promise<PoiCategoryDto[] | undefined> {
  // Placement can be INDOOR, OUTDOOR or ALL
  const endpoint =
    placement !== undefined
      ? `/v2/pois/categories/all?placement=${placement}`
      : `/v2/pois/categories/all`
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {
    console.error(e)
  }
}

export async function getCategoriesForBuilding(constructionId, cancelPendingRequest) {
  const endpoint = `/v2/pois/constructions/${constructionId}/categories`
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {
    console.error(e)
  }
}

export async function getCategoriesForLevel(levelId, cancelPendingRequest = false) {
  const endpoint = `/v2/pois/levels/${levelId}/categories`
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {}
}

export async function getPoiCategoriesForRealEstate(realEstateId, cancelPendingRequest = false) {
  const endpoint = `/v2/pois/realestate/${realEstateId}/categories`
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {}
}

export async function getPoiById(
  poiId,
  cancelPendingRequest = false
): Promise<PoiProperties | undefined> {
  const endpoint = `/v2/pois/${poiId}`
  const response = await getRequestv1(endpoint, cancelPendingRequest)
  if (response) {
    response.data.guid = response.data.id
    response.data.longitude = response.data.location.coordinates[0]
    response.data.latitude = response.data.location.coordinates[1]
    return response.data
  } else return undefined
}

// Not used? Remove?
export async function getPoisById(poiIds: string[], cancelPendingRequest = false) {
  const endpoint = `/v2/pois/geojson`
  try {
    const response = await postRequest(endpoint, poiIds, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {}
}

export async function getPoisForSelectedLevelPerCategory(
  categoryId,
  levelId,
  typeId,
  cancelPendingRequest = false
) {
  const endpoint = `/v2/pois/levels/${levelId}/geojson?categoryId=${categoryId}&typeId=${typeId}`
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {}
}

export async function getPoisForSelectedRealEstatePerCategory(
  categoryId,
  realEstateId,
  typeId,
  cancelPendingRequest = false
) {
  const endpoint = `/v2/pois/realestate/${realEstateId}/geojson?categoryId=${categoryId}&typeId=${typeId}`
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {}
}
/**
 * sync new info on a backend poi, edited in IVION
 * @param id Backend poi id
 */
export async function syncBackendPoi(id: string) {
  const endpoint = `/v2/pois/sync`
  const body = {
    id: id,
    navVisId: null,
    siteUrl: null
  }
  await postRequest(endpoint, body, false)
}
/**
 * sync a new poi to backend, created in IVION
 * @param navVisId navVis poi id
 * @param siteUrl navVis site url
 */
export async function syncNavvisPoi(navVisId: number, siteUrl: string) {
  const endpoint = `/v2/pois/sync`
  const body = {
    id: null,
    navVisId: navVisId,
    siteUrl: siteUrl
  }
  await postRequest(endpoint, body, false)
}

/**
 * delete poi on backend (CURRENLTY ON HOLD BECAUSE OF UNRELIABLE onPoiDelete)
 * @param id BE poi-id
 */
// export function deleteBackendPoi(id: string) {
//   const endpoint = `/v2/pois/${id}/_sync`
//   try {
//     deleteRequest(endpoint, false)
//     console.log('creating poi on BE')
//   } catch (e) {}
// }
export async function getPoiSummaryForLevel(levelId, cancelPendingRequest = false) {
  const endpoint = `/v2/pois/levels/${levelId}/summary`
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {}
}

export async function getPoiSummaryForConstruction(constructionId, cancelPendingRequest = false) {
  const endpoint = `/v2/pois/constructions/${constructionId}/summary`
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {}
}

export async function getPoiSummaryForRealEstate(realEstateId, cancelPendingRequest = false) {
  const endpoint = `/v2/pois/realestate/${realEstateId}/summary`
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    if (response) return response.data
  } catch (e) {}
}

/**
 * Update backend poi with new data (from planview)
 * @param id poi id
 * @param body request object
 */
export async function updatePoi(id: string, body: RequestPoi) {
  const endpoint = `/poi/v2/pois/${id}`
  const res = await putRequestGateway(endpoint, body)
  return res.data
}
/**
 * create poi on backend and in NavVis (from planview)
 * @param body Requestbody with NavvisPoi to sync with NavVis
 */
export async function createPoi(body: RequestPoi) {
  const endpoint = `/poi/v2/pois`
  const res = await postRequestGateway(endpoint, body)
  return res.data
}

export async function syncIndoorview(body: IndoorviewPoiInfo) {
  const endpoint = `/poi/v2/pois/indoorview`
  const res = await postRequestGateway(endpoint, body)
  return res.data
}
